<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-row>
            <b-col sm="12">
              <b-card v-if=" show==1 " header-class="redmfu">
                <div slot="header">
                  <strong v-if="thai_student==1">ตอนที่ 4 การศึกษาต่อ</strong>
                  <strong v-else>Part 4 For graduates doing/wanting to do further studies</strong>
                </div>
                <div v-for="item in items" v-bind:key="item.QUESTION_PK">
                  <div v-if="item.QUESTION_PK==42">
                    <strong>35. {{ item.QUESTION_NAME }} </strong>
                    <br/>
                    <p>{{ selected_level_edu }} : {{ ans42 }}</p>
                  </div>
                  <div v-if="item.QUESTION_PK==43">
                    <strong>36. {{ item.QUESTION_NAME }}</strong>
                    <br/>
                    <p
                      v-if="selected_program_edu==2"
                    >{{ selected_program_edu }} : {{ ans43 }} {{ selected_program_id }} {{ selected_program_name }}</p>
                    <p v-else>{{ selected_program_edu }} : {{ ans43 }}</p>
                  </div>
                  <div v-if="item.QUESTION_PK==43">
                    <strong v-if="thai_student==1"> คณะ/สำนักวิชาที่ต้องการศึกษาต่อ หรือ กำลังศึกษาต่อ </strong>
                    <strong v-else>In which faculty/school are you pursuing further studies?</strong>
                    : {{ txt_faculty }}
                  </div> <br>
                  <div v-if="item.QUESTION_PK==44">
                    <strong>37. {{ item.QUESTION_NAME }}</strong>
                    <br/>
                    <p>{{ selected_type_univ }} : {{ ans44 }}</p>
                  </div>
                  <div v-if="item.QUESTION_PK==44">
                    <strong v-if="thai_student==1">  ชื่อสถาบันที่ต้องการศึกษาต่อ หรือ กำลังศึกษาต่อ
                    </strong>
                    <strong v-else>Name of educational institution
                    </strong>
                    : {{ txt_university }}<br><br>
                    <strong v-if="thai_student==1"> ที่อยูู่่ของสถาบันการศึกษาที่ศึกษาต่อ

                    </strong>
                    <strong v-else>Address of educational institution

                    </strong>
                    : {{ txt_address_uni }}<br>
                  </div>

                  <div v-if="item.QUESTION_PK==45">
                    <strong>38. {{ item.QUESTION_NAME }}</strong>
                    <br/>
                    <p v-if="selected_cause_edu==0">{{ selected_cause_edu }} : {{ ans45 }} <u>{{ qn_cause_edu_txt }}</u>
                    </p>
                    <p v-else>{{ selected_cause_edu }} : {{ ans45 }}</p>
                  </div>
                  <div v-if="item.QUESTION_PK==46">
                    <strong>39. {{ item.QUESTION_NAME }}</strong>
                    <br/>
                    <br/>
                    <p v-if="selected_prob_edu_0==1">0 : {{ ans46_0 }}: <u>{{ qn_prob_edu_txt }}</u></p>
                    <p v-if="selected_prob_edu_1==1">1 : {{ ans46_1 }} </p>
                    <p v-if="selected_prob_edu_2==1">2 : {{ ans46_2 }} </p>
                    <p v-if="selected_prob_edu_3==1">3 : {{ ans46_3 }} </p>
                    <p v-if="selected_prob_edu_4==1">4 : {{ ans46_4 }} </p>
                    <p v-if="selected_prob_edu_5==1">5 : {{ ans46_5 }} </p>
                  </div>
                </div>
                <!--                <table align=center>-->
                <div slot="footer" class="text-right">
                  <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                    <i class="fa fa-arrow-circle-o-left"></i> Back
                  </b-button>
                  <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onNext">
                    <i class="fa fa-arrow-circle-o-right"></i> Next
                  </b-button>
                </div>
                <!--                </table>-->
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
    <div>
      <div class="mb-2">
        <!-- <b-button @click="showMsgBoxOne"  >Simple msgBoxOk</b-button> -->
      </div>
    </div>
  </div>
</template>
<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
import {toUnicode} from "punycode";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      boxOne: '',
      boxTwo: '',
      std_id: "",
      successModal: false,
      student: {},
      sex: "",
      studentCode: "",
      thai_student: "",
      prefixName: "",
      studentName: "",
      studentSurname: "",
      studentNameEng: "",
      studentSurnameEng: "",
      prefixNameEng: "",
      levelGroupNameEng: "",
      facultyName: "",
      facultyNameEng: "",
      departmentName: "",
      departmentNameEng: "",
      current_erorrtxt: "",

      selected_level_edu: "",

      selected_program_edu: "",
      programItems: [],
      selected_program_id: "",
      selected_program_name: "",

      selected_type_univ: "",
      selected_cause_edu: "",
      qn_cause_edu_txt: "",
      selected_prob_edu: "",
      qn_prob_edu_txt: "",
      selected_prob_edu_0: "",
      selected_prob_edu_1: "",
      selected_prob_edu_2: "",
      selected_prob_edu_3: "",
      selected_prob_edu_4: "",
      selected_prob_edu_5: "",
      selected_prob_edu_6: "",
      qn_work_status: "",

      txt_faculty: "",
      txt_university: "",
      txt_address_uni: "",

      items: [],

      ans42: "",
      ans43: "",
      ans43_1: "",
      ans44: "",
      ans45: "",

      ans46_0: "",
      ans46_1: "",
      ans46_2: "",
      ans46_3: "",
      ans46_4: "",
      ans46_5: "",
      show: "",
    };
  },

  methods: {
    showMsgBoxOne() {
      this.boxOne = ''
      this.$bvModal.msgBoxOk('บันทึกสำเร็จ ขอบคุณสำหรับความร่วมมือ Thank you')
        .then(value => {
          this.boxOne = value
          this.$router.push("logout");
        })
        .catch(err => {
          // An error occurred
        })
    },
    getErrorTxt: function () {
      this.numEror = 1;
      console.log("this.numEror==", this.numEror);
      this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "บันทึกสำเร็จ ขอบคุณสำหรับความร่วมมื" : this.current_erorrtxt + "Thanks";
      console.log("this.current_erorrtxt==", this.current_erorrtxt);
      this.successModal = true;
      return this.numEror;
    },
    onBack() {
      this.$router.push("employment");
    },
    onNext() {
      this.$router.push("employment5");
    },
    showModal() {
      this.showMsgBoxOne();
      // this.$refs['my-modal'].show();
      // this.$router.push("Logout");
    },
    onSubmit() {
      this.showModal();
      // this.numEror = this.getErrorTxt();
      // this.$router.push("Logout");
    },
    getAns(question, ans, thaistudent) {
      api
        .getSybytedesByAns(question, ans, thaistudent)
        .then(res => {

          var currentSt = res.data.data[0];
          // console.log("this.show==", this.show);
          // if (this.show==1) {
          if (res.data.data.length > 0) {

            if (question == "QN_LEVEL_EDU") {
              this.ans42 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PROGRAM_EDU_ID") {
              // console.log("this.ans==", this.ans);
              this.ans43 = res.data.data[0].BYTEDES;

              // console.log("this.ans43xxxxxx==", this.ans43);
            }
            if (question == "QN_TYPE_UNIV") {
              this.ans44 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_CAUSE_EDU") {
              this.ans45 = res.data.data[0].BYTEDES;
            }
            if (question == "QN_PROB_EDU") {
              this.ans46_1 = res.data.data[0].BYTEDES;
              // console.log("this.ans46==", this.ans46);
            }
            if (question == "QN_PROB_EDU0") {
              this.ans46_0 = res.data.data[0].BYTEDES;
              // console.log("this.ans46==", this.ans46);
            }
            if (question == "QN_PROB_EDU2") {
              this.ans46_2 = res.data.data[0].BYTEDES;
              // console.log("this.ans46==", this.ans46);
            }
            if (question == "QN_PROB_EDU3") {
              this.ans46_3 = res.data.data[0].BYTEDES;
              // console.log("this.ans46==", this.ans46);
            }
            if (question == "QN_PROB_EDU4") {
              this.ans46_4 = res.data.data[0].BYTEDES;
              // console.log("this.ans46==", this.ans46);
            }
            if (question == "QN_PROB_EDU5") {
              this.ans46_5 = res.data.data[0].BYTEDES;
              // console.log("this.ans46==", this.ans46);
            }
            //  }
          }
        })
        .catch(err => {
          console.log(2);
          console.log("getSybytedesByAns", err.toString());
        });
    },
    selectProgramOnchange() {
      api
        .getProgramEduById(this.selected_program_id, this.thai_student)
        .then(res => {
          this.selected_program_name = res.data.data[0].PROGRAM_NAME;
          console.log("selectProgramOnchange", this.selected_program_name);
        })
        .catch(err => {
          console.log(2);
          console.log("2", err.toString());
        });
    },
    getQuestion: function (section, sex, thaistudent) {
      api
        .getQuestionBySection(section, sex, thaistudent)
        .then(res => {
          this.items = res.data.data;
          // console.log("getQuestion==", this.items);
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
    getProgram: function (thaistudent) {
      api
        .getProgramEduAll(thaistudent)
        .then(res => {
          this.programItems = res.data.data;
          // console.log(this.items);
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
    getCurrentStudent(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          // console.log(res)
          if (res.data.data.length > 0) {
            var currentSt = res.data.data[0];
            if (currentSt.QN_REQUIRE_EDU == 2) { // ไม่เรียนต่อ
              this.$router.push("employment5");
            } else {
              this.std_id = studentid;
              this.thai_student = currentSt.THAI_STUDENT;
              this.sex = currentSt.SEX;
              this.qn_work_status = currentSt.QN_WORK_STATUS;
              this.show = 1;

              if ((currentSt.QN_LEVEL_EDU == '') || (currentSt.QN_LEVEL_EDU == null)) {
                this.show = 0;
              }
              // console.log("show==", this.show)
              // console.log("279this.show==",this.show);
              if (this.show == 1) {
                this.selected_level_edu = currentSt.QN_LEVEL_EDU;
                this.selected_program_edu = currentSt.QN_PROGRAM_EDU;
                this.selected_program_id = currentSt.QN_PROGRAM_EDU_ID;
                this.selected_program_name = currentSt.QN_PROGRAM_EDU_NAME;
                this.selected_type_univ = currentSt.QN_TYPE_UNIV;
                this.selected_cause_edu = currentSt.QN_CAUSE_EDU;
                this.qn_cause_edu_txt = currentSt.QN_CAUSE_EDU_TXT;
                this.txt_faculty = currentSt.QN_FACULTY;
                this.txt_university = currentSt.QN_UNIVERSITY;
                this.txt_address_uni = currentSt.QN_ADD_UNIVERSITY;
                // console.log("xxx==", this.qn_cause_edu_txt);
                // this.selected_prob_edu_0=currentSt.QN_CAUSE_EDU0
                // this.selected_prob_edu_1 = currentSt.QN_PROB_EDU;
                // this.selected_prob_edu_2 = currentSt.QN_PROB_EDU2;
                // this.selected_prob_edu_3 = currentSt.QN_PROB_EDU3;
                // this.selected_prob_edu_4 = currentSt.QN_PROB_EDU4;
                // this.selected_prob_edu_5 = currentSt.QN_PROB_EDU5;
                // this.selected_prob_edu_6 = currentSt.QN_PROB_EDU6;
                this.qn_prob_edu_txt = currentSt.QN_PROB_EDU_TXT;
                // console.log("qn_prob_edu_txt==",this.qn_prob_edu_txt);
                this.getQuestion(4, this.sex, this.thai_student);
                if (currentSt.QN_PROB_EDU == 1) {
                  this.selected_prob_edu_1 = currentSt.QN_PROB_EDU;
                  // this.ans46_1="ไม่มีปัญหา";
                  // this.ans46_1="No Problems";
                  this.ans46_1 = this.thai_student == "1" ? "ไม่มีปัญหา" : "No Problems";
                  this.qn_prob_edu_txt = "";
                } else {
                  var selectedData = [];
                  var j = -1;
                  if (currentSt.QN_PROB_EDU0 != null) {
                    j = j + 1;
                    selectedData[j] = 0;
                  }
                  if (currentSt.QN_PROB_EDU2 != null) {
                    j = j + 1;
                    selectedData[j] = 2;
                  }
                  if (currentSt.QN_PROB_EDU3 != null) {
                    j = j + 1;
                    selectedData[j] = 3;
                  }
                  if (currentSt.QN_PROB_EDU4 != null) {
                    j = j + 1;
                    selectedData[j] = 4;
                  }
                  if (currentSt.QN_PROB_EDU5 != null) {
                    j = j + 1;
                    selectedData[j] = 5;
                    this.qn_prob_edu_txt = currentSt.QN_PROB_EDU_TXT;
                  }
                  this.selected_prob_edu = selectedData;
                  this.selected_prob_edu_0 = currentSt.QN_PROB_EDU0;
                  this.selected_prob_edu_1 = currentSt.QN_PROB_EDU;
                  this.selected_prob_edu_2 = currentSt.QN_PROB_EDU2;
                  this.selected_prob_edu_3 = currentSt.QN_PROB_EDU3;
                  this.selected_prob_edu_4 = currentSt.QN_PROB_EDU4;
                  this.selected_prob_edu_5 = currentSt.QN_PROB_EDU5;
                  this.selected_prob_edu_6 = currentSt.QN_PROB_EDU6;

                }
                if (this.selected_prob_edu_0 == 1) {
                  this.getAns("QN_PROB_EDU0", 0, this.thai_student);
                }
                if (this.selected_prob_edu_1 == 1) {

                  //this.getAns("QN_PROB_EDU", 1, this.thai_student);
                }
                if (this.selected_prob_edu_2 == 1) {
                  this.getAns("QN_PROB_EDU2", 2, this.thai_student);
                }
                if (this.selected_prob_edu_3 == 1) {
                  this.getAns("QN_PROB_EDU3", 3, this.thai_student);
                }
                if (this.selected_prob_edu_4 == 1) {
                  this.getAns("QN_PROB_EDU4", 4, this.thai_student);
                }
                if (this.selected_prob_edu_5 == 1) {
                  this.getAns("QN_PROB_EDU5", 5, this.thai_student);
                }


                this.getAns(
                  "QN_LEVEL_EDU",
                  this.selected_level_edu,
                  this.thai_student
                );
                // console.log("selected_program_edu==", this.selected_program_edu);

                this.getAns(
                  "QN_PROGRAM_EDU_ID",
                  this.selected_program_edu,
                  this.thai_student
                );

                this.getAns(
                  "QN_TYPE_UNIV",
                  this.selected_type_univ,
                  this.thai_student
                );
                // console.log("selected_cause_edu==", this.selected_cause_edu);
                this.getAns(
                  "QN_CAUSE_EDU",
                  this.selected_cause_edu,
                  this.thai_student
                );
                // this.getAns(
                //   "QN_PROB_EDU",
                //   this.selected_prob_edu,
                //   this.thai_student
                // );
              }
            }
          }
        })
        .catch(err => {
          console.log("getCurrentStudent", err.toString());
        });
    }
  },
  mounted() {
  },
  created() {

    // console.log("Part4444444==",this.$store.state.user.studentid);
    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/Login_63");
    } else {
      // this.$router.push("/Dashboard");
    }
    this.std_id = this.$store.state.user.studentid;
    api.onSetHeader();
    this.actionUpdate = this.getCurrentStudent(this.std_id);
    // console.log("show", this.show);

  }
};
</script>
<style>
</style>
